export class ForgotPasswordConstans {
  public static FILTERS_OK = 1;
  public static ENTER_FILTERS_AGAIN = 2;
  public static USER_IS_LOCKED = 3;
  public static USER_WAS_NOT_PROCESSED = 4;
}
